import type { Theme } from '@mui/material/styles';
import type { SystemStyleObject } from '@mui/system';
import type { CustomPaletteColor, PillButtonFieldProps } from './types';

export const pillChipRootStyles: SystemStyleObject<Theme> = {
  borderRadius: '16px',
  height: 'auto',
  width: 'fit-content',
  cursor: 'pointer',
  '& .MuiChip-label': {
    padding: '4px 12px',
  },
};

export const pillChipCustomStyles = (
  custom: CustomPaletteColor,
  variant: PillButtonFieldProps['variant']
): SystemStyleObject<Theme> => ({
  backgroundColor: variant === 'filled' ? custom.light : 'transparent',
  color: custom.dark,
  border: variant === 'outlined' ? `1px solid ${custom.dark}` : 'none',
  '&:hover': {
    backgroundColor: custom.light,
  },
});
